var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmergingAndDevelopingTechnologies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.26 64.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:3.14px;}.cls-1,.cls-2,.cls-3{stroke:#fff;}.cls-1,.cls-3{fill:none;}.cls-2{fill:#277bfa;stroke-miterlimit:10;}.cls-3{stroke-miterlimit:4;stroke-width:3.14px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.13,
    cy: 32.23,
    r: 6.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 36.13,
    cy: 32.23,
    rx: 34.56,
    ry: 13.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 36.13,
    cy: 32.23,
    rx: 13.2,
    ry: 34.56,
    transform: "translate(-11.27 22.38) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 36.13,
    cy: 32.23,
    rx: 34.56,
    ry: 13.2,
    transform: "translate(-9.84 47.4) rotate(-60)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergingAndDevelopingTechnologies);
export default __webpack_public_path__ + "static/media/emerging-and-developing-technologies.e290afdcd578e96a318df843da2abe0c.svg";
export { ForwardRef as ReactComponent };